import * as Types from './types';
import { createReducer } from '../../utils';

const initialState = {
  loading: false,
  error: null,
  formValues: '',
  contactInfo: null,
  postingPreview: null
};

const step4Module3Reducer = createReducer(initialState)({
  [Types.GET_STEP_PRESENTATION]: state => ({ ...state, error: null, loading: true }),
  [`${Types.GET_STEP_PRESENTATION}_COMPLETED`]: (state, action) => ({ ...state, ...action.payload }),
  [`${Types.GET_STEP_PRESENTATION}_FAILED`]: (state, action) => ({ ...state, error: action.payload, loading: false }),
  [Types.SAVE_STEP_PRESENTATION]: state => ({ ...state, error: null, loading: true }),
  [`${Types.SAVE_STEP_PRESENTATION}_COMPLETED`]: (state, action) => ({ ...state, ...action.payload }),
  [`${Types.SAVE_STEP_PRESENTATION}_FAILED`]: (state, action) => ({ ...state, error: action.payload, loading: false })
});

export { step4Module3Reducer };
